import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetAnalyse } from "../Widgets/WidgetAnalyse";
import { WaitPanelComponent } from "../../Table/WaitPanelComponent";
import { app } from "../../../Frame/App";
import { ChartValue } from "../Charts/ChartValue";
import { ChartTypes } from "../Charts/ChartTypes";
import { DonutChart } from "../Charts/DonutChart";
import { BarChart } from "../Charts/BarChart";
import { WaterfallChart } from "../Charts/WaterfallChart";
import { IAnalyseResponse } from "../Server/IAnalyseResponse";
import { ECONNRESET } from "constants";

export type WidgetAnalyseComponentProps = {
    widget: WidgetAnalyse;
}

export class WidgetAnalyseComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetAnalyseComponentProps;
    waitPanel: HTMLElement;

    constructor(props: WidgetAnalyseComponentProps) {
        super(props);
    }

    renderWaitPanel(): HTMLElement {
        this.waitPanel = <WaitPanelComponent />
        return this.waitPanel;
    }

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.widget.props.title[`value${app.languageUpperCase}`] && this.props.widget.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.widget.props.title[`value${app.languageUpperCase}`] : this.props.widget.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                {this.renderWaitPanel()}
            </div>
        </div>;

    renderBar(index: number, chartValues: ChartValue[], factor: number): HTMLElement {
        let value = 0;
        if (chartValues && index < chartValues.length) {
            value = chartValues[index].value;
        }

        if (value > 0) {
            return <Fragment>
                {chartValues[index].name
                    ? <div className="a-bar-header">{chartValues[index].name}</div>
                    : []}
                
                <div className={chartValues[index].className + " a-bar"} style={{ "height": (value * factor).toString() + "%" }}>
                    <div className="a-label">{value}</div>
                </div>
            </Fragment>
        }

        return null;
    }

    renderWaterfall(index: number, chartValues: ChartValue[], factor: number, addEmpty: boolean = true): HTMLElement {
        let value = 0;
        let prev = 0;
        if (chartValues && index < chartValues.length) {
            value = chartValues[index].value;

            if (addEmpty) {
                for (let i = 0; i < index; i++) {
                    prev += chartValues[i].value;
                }
            }
        }

        if (value > 0) {
            return <Fragment>
                <div className={chartValues[index].className + " a-water"} style={{ "height": (value * factor).toString() + "%" }}>
                    <div className="a-label">{value}</div>
                </div>
                <div className={"a-empty-bar"} style={{ "height": (prev * factor).toString() + "%" }}></div>
            </Fragment>
        }

        return null;
    }

    renderChart(data: IAnalyseResponse, withTable: boolean): HTMLElement {
        let startGridIndex: number = 1;
        if (withTable) {
            startGridIndex = 3;
        }

        if (this.props.widget.props.chartType == ChartTypes.Donut) {
            let chart = new DonutChart();
                //return (
                //    <div className={""} style={{ "grid-area": "1 / 3 / 2 / 7" }}>
                //        {chart.create(data.chartValues)}
                //    </div>)

            return (<Fragment>
                    {chart.create(data.chartValues)}
            </Fragment>)
        }
        else if (this.props.widget.props.chartType == ChartTypes.Bar) {

            console.log(data);

            // get max value
            let max = 0;
            for (let value of data.chartValues) {
                if (max < value.value) {
                    max = value.value;
                }
            }
            let factor = max > 0 ? 100 / max : 1;

            if (!this.props.widget.props.splitBy || this.props.widget.props.splitBy == "ampel") {
                let result = (
                    <Fragment>
                        <div className="a-chart" style={{ "grid-area": `1 / ${startGridIndex + 0} / 2 / ${startGridIndex + 1}` }}>{this.renderBar(0, data.chartValues, factor)}</div>
                        <div className="a-chart" style={{ "grid-area": `1 / ${startGridIndex + 1} / 2 / ${startGridIndex + 2}` }}>{this.renderBar(1, data.chartValues, factor)}</div>
                        <div className="a-chart" style={{ "grid-area": `1 / ${startGridIndex + 2} / 2 / ${startGridIndex + 3}` }}>{this.renderBar(2, data.chartValues, factor)}</div>
                        <div className="a-chart" style={{ "grid-area": `1 / ${startGridIndex + 3} / 2 / ${startGridIndex + 4}` }}>{this.renderBar(3, data.chartValues, factor)}</div>
                    </Fragment>)

                return result;
            } else if (this.props.widget.props.splitBy == "status") {
                let result = (
                    <Fragment>
                        {data.chartValues.map((c, index) => 
                            <div className="a-chart" style={{ "grid-area":  `1 / ${startGridIndex + index} / 2 / ${startGridIndex + index + 1}` }}>{this.renderBar(index, data.chartValues, factor)}</div>
                        )}
                    </Fragment>)

                return result;
            } else {
                // This should not happen
                let result = <div className="a-chart" style={{ "grid-area": `1 / ${startGridIndex} / 2 / 4` }}></div>
                return result;
            }
        }
        else {
            // get max and total value
            let total = 0;
            for (let value of data.chartValues) {
                total += value.value;
            }
            let factor = total > 0 ? 100 / total : 1;

            let totalValue = new ChartValue();
            totalValue.className = "a-chart-grey";
            totalValue.value = total;
            data.chartValues.push(totalValue);

            //let result = (
            //    <Fragment>
            //        <div className="a-chart" style={{ "grid-area": "1 / 2 / 2 / 3" }}>{this.renderWaterfall(0, data.chartValues, factor)}</div>
            //        <div className="a-chart" style={{ "grid-area": "1 / 3 / 2 / 4" }}>{this.renderWaterfall(1, data.chartValues, factor)}</div>
            //        <div className="a-chart" style={{ "grid-area": "1 / 4 / 2 / 5" }}>{this.renderWaterfall(2, data.chartValues, factor)}</div>
            //        <div className="a-chart" style={{ "grid-area": "1 / 5 / 2 / 6" }}>{this.renderWaterfall(3, data.chartValues, factor)}</div>
            //        <div className="a-chart" style={{ "grid-area": "1 / 6 / 2 / 7" }}>{this.renderWaterfall(4, data.chartValues, factor, false)}</div>
            //    </Fragment>)

            let result = (
                <Fragment>
                    <div className="a-chart" style={{ "grid-area": "1 / 1 / 2 / 2" }}>{this.renderWaterfall(0, data.chartValues, factor)}</div>
                    <div className="a-chart" style={{ "grid-area": "1 / 2 / 2 / 3" }}>{this.renderWaterfall(1, data.chartValues, factor)}</div>
                    <div className="a-chart" style={{ "grid-area": "1 / 3 / 2 / 4" }}>{this.renderWaterfall(2, data.chartValues, factor)}</div>
                    <div className="a-chart" style={{ "grid-area": "1 / 4 / 2 / 5" }}>{this.renderWaterfall(3, data.chartValues, factor)}</div>
                    <div className="a-chart" style={{ "grid-area": "1 / 5 / 2 / 6" }}>{this.renderWaterfall(4, data.chartValues, factor, false)}</div>
                </Fragment>)

            return result;
        }
    }

    renderTotal(data: IAnalyseResponse): HTMLElement {
        if (this.props.widget.props.chartType != ChartTypes.Waterfall) {
            let total = 0;
            for (let value of data.chartValues) {
                total += value.value;
            }
            return (
                <Fragment>
                    <div className={"a-total "} style={{ "grid-area": "1 / 1 / 2 / 2" }}>
                        {Resources["WidgetClient"].total}
                    </div>
                    <div className={"a-total  text-center"} style={{ "grid-area": "1 / 2 / 2 / 3" }}>
                        {total}
                    </div>
                </Fragment>)
        }
        return null;
    }

    renderTable(data: IAnalyseResponse): HTMLElement[] {
        let result: HTMLElement[] = [];

        if (data.templates) {
            let row = 2;
            for (let template of data.templates) {
                result.push(<div className={"a-cell"} style={{ "grid-area": `${row} / 1 / ${row + 1} / 2` }}><span className="a-text">{template.name}</span></div>)
                let col = 3;
                if (this.props.widget.props.chartType == ChartTypes.Waterfall) {
                    col = 2;
                    result.push(<div className="a-cell" style={{ "grid-area": `${row} / 6 / ${row + 1} / 7` }}><span className="a-text text-center">{template.red + template.yellow + template.blue + template.green}</span></div>)
                }
                else {
                    result.push(<div className="a-cell" style={{ "grid-area": `${row} / 2 / ${row + 1} / 3` }}><span className="a-text text-center">{template.red + template.yellow + template.blue + template.green}</span></div>)
                }
                result.push(<div className="a-cell" style={{ "grid-area": `${row} / ${col} / ${row + 1} / ${col + 1}` }}><span className="a-text text-center">{template.green}</span></div>)
                col++;
                result.push(<div className="a-cell" style={{ "grid-area": `${row} / ${col} / ${row + 1} / ${col + 1}` }}><span className="a-text text-center">{template.blue}</span></div>)
                col++;
                result.push(<div className="a-cell" style={{ "grid-area": `${row} / ${col} / ${row + 1} / ${col + 1}` }}><span className="a-text text-center">{template.yellow}</span></div>)
                col++;
                result.push(<div className="a-cell" style={{ "grid-area": `${row} / ${col} / ${row + 1} / ${col + 1}` }}><span className="a-text text-center">{template.red}</span></div>)
                row++;
            }
        }

        return result;
    }

    renderChartWithTable(data: IAnalyseResponse): HTMLElement {
        let result = (
            <div className={"analyse-grid with-table"} style={this.getGridStyle(data) ?? ""}>
                {this.renderChart(data, true)}
                {this.renderTotal(data)}
                {...this.renderTable(data)}
            </div>)

        return result;
    }

    private getGridStyle = (data: IAnalyseResponse) => {
        let style;
        if (this.props.widget.props.splitBy == "status") {
            let templateColumns = "";
            for (let chartValues of data.chartValues) {
                templateColumns += "1fr ";
            }
            templateColumns = templateColumns.substring(0, templateColumns.length - 1);

            style = { "grid-template-columns": templateColumns };
        } else {
            style = undefined
        }

        return style;
    }

    renderChartWithoutTable(data: IAnalyseResponse): HTMLElement {
        let classe = "analyse-grid without-table";
      
        if (this.props.widget.props.chartType == ChartTypes.Donut){
            classe = "analyse-grid with-donat"
        }
        else if (this.props.widget.props.chartType !== ChartTypes.Bar) {
            classe = "analyse-grid without-table-water"
        }
        let element = <div className={classe} style={this.getGridStyle(data) ?? ""}>
            {this.renderChart(data, false)}
        </div>;

        return element;


        //if (this.props.widget.props.chartType == ChartTypes.Donut) {
        //    let chart = new DonutChart();
        //    return (
        //        <div className={"analyse-grid with-donat"}>
        //            {chart.create(data.chartValues)}
        //        </div>)
        //}
        //else if (this.props.widget.props.chartType == ChartTypes.Bar) {
        //    // get max value
        //    let max = 0;
        //    for (let value of data.chartValues) {
        //        if (max < value.value) {
        //            max = value.value;
        //        }
        //    }
        //    let factor = max > 0 ? 100 / max : 1;




        //    let result = (
        //        <div className={"analyse-grid without-table"} style={this.getGridStyle(data)}>
        //            <div className="a-chart" style={{ "grid-area": "1 / 1 / 2 / 2" }}>{this.renderBar(0, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 2 / 2 / 3" }}>{this.renderBar(1, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 3 / 2 / 4" }}>{this.renderBar(2, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 4 / 2 / 5" }}>{this.renderBar(3, data.chartValues, factor)}</div>
        //        </div>)

        //    return result;
        //}
        //else {
        //    // get max and total value
        //    let total = 0;
        //    for (let value of data.chartValues) {
        //        total += value.value;
        //    }
        //    let factor = total > 0 ? 100 / total : 1;

        //    let totalValue = new ChartValue();
        //    totalValue.className = "a-chart-grey";
        //    totalValue.value = total;
        //    data.chartValues.push(totalValue);

        //    let result = (
        //        <div className={"analyse-grid without-table-water"}>
        //            <div className="a-chart" style={{ "grid-area": "1 / 1 / 2 / 2" }}>{this.renderWaterfall(0, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 2 / 2 / 3" }}>{this.renderWaterfall(1, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 3 / 2 / 4" }}>{this.renderWaterfall(2, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 4 / 2 / 5" }}>{this.renderWaterfall(3, data.chartValues, factor)}</div>
        //            <div className="a-chart" style={{ "grid-area": "1 / 5 / 2 / 6" }}>{this.renderWaterfall(4, data.chartValues, factor, false)}</div>
        //        </div>)

        //    return result;
        //}
    }

    renderContent(data: IAnalyseResponse): HTMLElement {
        let result: HTMLElement;
        let hasGreen: boolean = false;
        for (let template of data.templates) {
            if (template.green > 0) {
                hasGreen = true;
                break;
            }
        }

        if (this.props.widget.props.showWithTable) {
            result = this.renderChartWithTable(data);
        }
        else {
            result = this.renderChartWithoutTable(data);
        }

        if (!hasGreen && this.props.widget.props.splitBy == "ampel") {
            result.classList.add("no-green");
            result.classList.add(`no-green-${this.props.widget.props.chartType.toString()}`);
        }

        return result;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();

        // load data
        $.ajax({
            type: "POST",
            url: app.resolveUrl("~/api/widget/getAnalyseData"),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                templateIds: this.props.widget.props.templateIds,
                splitBy: this.props.widget.props.splitBy
            }),
            success: (data: IAnalyseResponse) => {
                let div = <div className="analyse-grid-outer">
                    {this.renderContent(data)}
                </div>
                this.waitPanel.parentElement.insertBefore(div, this.waitPanel);
                this.waitPanel.parentElement.removeChild(this.waitPanel);
                this.waitPanel = null;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });

        return this.element;
    }
}